import { PatientRepository } from "@/domain/repository/patient-repository";
import { TerminateTreatmentUsecase } from "@/domain/usecase/doctor/treatment/terminate-treatment-usecase";
import { SATError, SATResult } from "@sadtx/sat-error";

export class DeactivatePatientUsecase {
  //MARK:- Constructor
  constructor(
    private readonly patientRepo: PatientRepository,
    private readonly terminateTreatmentUsecase: TerminateTreatmentUsecase
  ) {}

  //MARK:- execute
  async execute(
    patientUuid: string,
    inProgressTreatmentUUIDs: string[]
  ): Promise<SATResult<void, SATError>> {
    // 진행 중인 처방이 있으면 먼저 종료
    if (inProgressTreatmentUUIDs.length > 0) {
      const terminateResults = await Promise.all(
        inProgressTreatmentUUIDs.map((treatmentUUID) =>
          this.terminateTreatmentUsecase.execute(treatmentUUID)
        )
      );

      // 처방 종료 실패 시 에러 반환
      for (const result of terminateResults) {
        if (result.isFailure) {
          return SATResult.failure(result.error);
        }
      }
    }

    // 환자 비활성화
    const result = await this.patientRepo.deactivatePatient(patientUuid);
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return SATResult.success(void 0);
  }
}
